module.exports = __webpack_public_path__ + "static/media/geospatial-overview.8c8e3712.svg";